@let configuration = configurationSg();

<div class="atn-space-report-progress-by-organization">
  <atn-ds-widget title="Configuration">
    <div class="atn-space-report-progress-by-organization__configuration">
      <div class="atn-space-report-progress-by-organization__selects">
        <atn-ds-select-single
          label="Entity"
          [items]="orgEntitySelectItems()"
          [value]="configuration.entityId"
          [required]="true"
          (valueChange)="entityIdChangeHandler($event)"
        />
        <atn-ds-select-single
          label="Format"
          [items]="formatItems"
          [value]="configuration.format"
          [required]="true"
          (valueChange)="formatChangeHandler($event)"
        />
      </div>
    </div>
  </atn-ds-widget>
</div>
